module.exports = {
  "factor": {
    "factor": "因子管理",
    "labelName": "因子名称",
    "labelType": "因子类型",
    "factorList": "标签列表",
    "remark": "备注",
    "createTime": "创建时间",
    "labelNameHint": "请输入因子名称",
    "labelTypeHint": "请输入因子类型",
    "remarkHint": '请输入备注',
  },
};


// WEBPACK FOOTER //
// ./src/i18n/factor/en.js